import React from 'react'

import InstallApp from '../../../components/InstallApp'
import { useLazyConnectQuery } from './calendly.service'
import { useAppDetailContext } from '../../AppDetailContext'

const InstallCalendly = () => {
  const { name } = useAppDetailContext()

  const [connect, connectResult] = useLazyConnectQuery()

  const handleLink = async () => {
    const promise = connect().unwrap()
    promise.then((data) => {
      window.location = data.oauth_url
    })
  }

  return <InstallApp name={name} onInstall={handleLink} isInstalling={connectResult.isLoading} />
}

export default InstallCalendly
